import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Dish from "../Dish";
import { useDispatch } from "react-redux";
import { remove_scroll } from "../../state/scrollSlice";

const Category = (props) => {
	const [dishes, setDishes] = useState([]);
	const [hide, setHide] = useState(false);
	const scrollToRef = useRef();
	const dispatch = useDispatch();
	const scroll = useSelector((state) => state.scroll.value);

	useEffect(() => {
		if (scroll === props.category.id) {
			scrollToRef.current.scrollIntoView({
				behavior: "smooth",
				block: "center",
				inline: "center",
			});
			dispatch(remove_scroll());
		}
	}, [scroll, props.category, dispatch]);

	useEffect(() => {
		const filtered = props.category.dishes.filter((m) =>
			m.name.toLowerCase().includes(props.search.toLowerCase())
		);

		setDishes(filtered);
	}, [props.category, props.search]);

	useEffect(() => {
		if (props.type !== null) {
			let filtered = props.category.dishes.filter((m) => m.type === props.type);

			setDishes(filtered);
		} else setDishes(props.category.dishes);
	}, [props.type, props.category]);

	return (
		<section
			className="fda_section_product_tile col-12"
			id={props.category.id}
			ref={scrollToRef}
		>
			<div className="row fda_title_row">
				<div className="col-12" onClick={() => setHide((h) => !h)}>
					<span>
						<p color="#363636" className="littleline1">
							{props.category.name}{" "}
							{hide ? (
								<i className="fa-solid fa-caret-up"></i>
							) : (
								<i className="fa-solid fa-caret-down"></i>
							)}
						</p>
					</span>
				</div>
			</div>
			{!hide && dishes.map((k, i) => <Dish dish={k} key={i} />)}
		</section>
	);
};

export default Category;
